module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-a.svg?b70e0c0e87b49a32cc307c72d897a0cd";